import { PlaytechTableList } from 'lib/datoCms/queries/getAllCasinoLiveCategoryPage';
import { DatoCmsGame } from 'lib/datoCms/types';
import { GamesTableDto } from 'types/swagger';

export function getSortedCasinoLive(listSlotCustom: DatoCmsGame[], listOfGames: Array<GamesTableDto>) {
  return listOfGames
    .filter((game) => {
      return listSlotCustom.some((slotCustom: DatoCmsGame) => {
        return `${slotCustom.middlewareId}` === `${game.id}`;
      });
    })
    .sort((a, b) => {
      const indexA = listSlotCustom.findIndex((slotCustom) => `${slotCustom.middlewareId}` === `${a.id}`);
      const indexB = listSlotCustom.findIndex((slotCustom) => `${slotCustom.middlewareId}` === `${b.id}`);
      return indexA - indexB;
    });
}

export const isFeedPlaytech = (tableList: any): tableList is PlaytechTableList => {
  return tableList && typeof tableList.feedName === 'string';
};
